// NotesApp source file : _components/manage.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from '../../_service/data.service';
import { UserSettingsService } from '../../_service/user-settings.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-manage',
    imports: [FormsModule, CommonModule],
    templateUrl: './manage.component.html',
    styleUrls: ['./manage.component.scss']
})

export class ManageComponent implements OnInit {
    availableThemes: string[] = [];
    selectedTheme: string = '';
    constructor(
        private data_service: DataService,
        private router: Router,
        private userSettingsService: UserSettingsService,
    ) {

    }


    ngOnInit(): void {
        this.userSettingsService.loadSavedTheme();
        this.selectedTheme = localStorage.getItem('selectedTheme') || this.availableThemes[0];
    }


    onThemeChange(event: any) {
        const selectedTheme = event.target.value;
        this.userSettingsService.applyTheme(selectedTheme);
    }
    home(): void {
        this.router.navigate(['/home']);
    }


    goToEditTags() {
        this.router.navigate(['/edit-tags']);
    }

    goToManageSpaces() {
        this.router.navigate(['/manage-spaces']);
    }

    goToManageAttachments() {
        this.router.navigate(['/manage-attachments']);
    }


    downloadNotesDB(): void {
        this.data_service.getAllNotes().subscribe(
            (data) => {
                const jsonStr = JSON.stringify(data, null, 2);
                const blob = new Blob([jsonStr], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const now = new Date();
                const timestamp = now.getFullYear().toString() +
                  (now.getMonth() + 1).toString().padStart(2, '0') +
                  now.getDate().toString().padStart(2, '0') + '-' +
                  now.getHours().toString().padStart(2, '0') +
                  now.getMinutes().toString().padStart(2, '0') +
                  now.getSeconds().toString().padStart(2, '0');

                const a = document.createElement('a');
                a.href = url;
                a.download = `NotesAppData_Backup_${timestamp}.json`;
                document.body.appendChild(a); // Append to body
                a.click();
                document.body.removeChild(a); // Remove from body

                window.URL.revokeObjectURL(url);
            },
            (error) => {
                console.error('Error downloading the notes:', error);
            }
        );
    }

}
